<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-text-field
          v-model="suche"
          append-icon="mdi-table-search"
          label="Suche"
          single-line
          hide-details
        />
      </v-col>
      <v-col>
        <v-switch
          v-model="showPrices"
          :label="`Zeige Umsätze`"
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="offerDataList"
      :search="suche"
      :options.sync="options"
      :footer-props="{
        itemsPerPageOptions: [-1, 50, 100],
      }"
      @click:row="navigateToPriceinformation"
    >
      <template #[`item.turnover`]="{ item }">
        {{ item.turnover ? moneyFormatter.format(item.turnover) : "-" }}
      </template>
      <template #[`item.turnover_one_time`]="{ item }">
        {{ item.turnover_one_time ? moneyFormatter.format(item.turnover_one_time) : "-" }}
      </template>
      <template #[`item.monthly_turnover`]="{ item }">
        {{ item.monthly_turnover ? moneyFormatter.format(item.monthly_turnover) : "-" }}
      </template>
      <template #[`item.company_name`]="{ item }">
        <inertia-link
          :href="
            route('customer.show.uebersicht', { customer: item.company_id })
          "
        >
          <span>{{ item.company_name }}</span>
        </inertia-link>
      </template>

      <template v-if="true" #[`item.performer_full_name`]="{ item }">
        <v-edit-dialog
          large
          save-text="speichern"
          cancel-text="zurück"
          @open="setPerformer(item.performer_id)"
          @save="savePerformer(item.id)"
        >
          {{ item.performer_full_name }}
          <template #input>
            <v-select
              v-model="performer"
              class="form-control"
              :items="performers"
              item-value="contact_person_id"
              item-text="name"
              label="Mitarbeiter"
            />
          </template>
        </v-edit-dialog>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-menu v-if="actionMenu" offset-y>
          <template #activator="{ on }">
            <v-btn v-on="on">
              aktionen
            </v-btn>
          </template>
          <v-list>
            <inertia-link :href="route('offerData.edit', item.id)">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-pencil </v-icon>
                </v-list-item-icon>
                <v-list-item-title>Bearbeiten</v-list-item-title>
              </v-list-item>
            </inertia-link>
            <inertia-link
              :href="route('offerData.replicate', item.id)"
              method="post"
              as="button"
            >
              <v-list-item>
                <v-list-item-icon>
                  <v-icon> mdi-content-copy </v-icon>
                </v-list-item-icon>
                <v-list-item-title>Kopieren</v-list-item-title>
              </v-list-item>
            </inertia-link>

            <v-list-item>
              <v-list-item-icon>
                <v-icon> mdi-publish </v-icon>
              </v-list-item-icon>
              <v-list-item-title @click.stop="setPublishOffer(item)">
                Freigeben
              </v-list-item-title>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="error">
                  mdi-delete-outline
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title
                class="error--text"
                @click.stop="deleteItem(item)"
              >
                Löschen
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <div v-else>
          <inertia-link :href="route('offerData.edit', item.id)">
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon class="mr-3" v-bind="attrs" v-on="on">
                  mdi-pencil
                </v-icon>
              </template>
              <span>bearbeiten</span>
            </v-tooltip>
          </inertia-link>

          <inertia-link
            :href="route('offerData.replicate', item.id)"
            method="post"
            as="button"
          >
            <v-tooltip bottom>
              <template #activator="{ on, attrs }">
                <v-icon class="mr-3" v-bind="attrs" v-on="on">
                  mdi-content-copy
                </v-icon>
              </template>
              <span>kopieren</span>
            </v-tooltip>
          </inertia-link>

          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon
                class="mr-3"
                v-bind="attrs"
                @click.stop="setPublishOffer(item)"
                v-on="on"
              >
                mdi-publish
              </v-icon>
            </template>
            <span>freigeben</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-icon
                color="error"
                v-bind="attrs"
                @click.stop="deleteItem(item)"
                v-on="on"
              >
                mdi-delete-outline
              </v-icon>
            </template>
            <span>löschen</span>
          </v-tooltip>
        </div>
      </template>
      <template #[`item.created_at`]="{ item }">
        {{ getDateString(item.created_at) }}
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Freigabe-Einstellungen</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select v-model="term" :items="terms" label="Laufzeit" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn left @click="dialog = false">
            zurück
          </v-btn>
          <v-spacer />
          <v-btn color="primary" @click="publishItem">
            freigeben
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'
import axios from 'axios'
import { formattedDateTimeString } from '@/plugins/formatDate.js'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Preisinformationen',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      offerDataList: {
         type: Array,
         required: true,
      },
      performers: {
         type: Array,
         required: true,
      },
   },
   remember: {
      data: ['showPrices', 'options', 'suche'],
      key: 'Offers/Index',
   },
   data () {
      return {
         loading: false,
         suche: '',
         dialog: false,
         showPrices: true,
         options: {
            page: 1,
            itemsPerPage: 50,
            sortBy: ['created_at'],
            sortDesc: [true],
            multiSort: false,
         },
         term: 3,
         terms: [
            { text: '36 Monate', value: 2 },
            { text: '60 Monate', value: 3 },
         ],
         publishOffer: null,
         performer: null,
         moneyFormatter: new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
         }),
      }
   },
   computed: {
      actionMenu () {
         return this.$vuetify.breakpoint.width < 1264
      },
      headers () {
         if (this.showPrices) {
            return [
               {
                  text: 'Nr.',
                  align: 'start',
                  sortable: true,
                  filterable: true,
                  value: 'id',
               },
               {
                  text: 'Status',
                  value: 'status',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Kunde',
                  value: 'company_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Angebotstyp',
                  value: 'angebot_type',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'VB',
                  value: 'performer_full_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Umsatz Ges.',
                  value: 'turnover',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Umsatz Einm.',
                  value: 'turnover_one_time',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Umsatz Mtl.',
                  value: 'monthly_turnover',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Laufzeit in M',
                  value: 'months',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Datum',
                  value: 'created_at',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Aktionen',
                  value: 'actions',
                  sortable: false,
                  filterable: false,
                  width: '20%',
               },
            ]
         } else {
            return [
               {
                  text: 'Nr.',
                  align: 'start',
                  filterable: true,
                  sortable: true,
                  value: 'id',
               },
               {
                  text: 'Status',
                  value: 'status',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Kunde',
                  value: 'company_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Angebotstyp',
                  value: 'angebot_type',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'VB',
                  value: 'performer_full_name',
                  sortable: true,
                  filterable: true,
               },
               {
                  text: 'Datum',
                  value: 'created_at',
                  sortable: true,
                  filterable: false,
               },
               {
                  text: 'Aktionen',
                  value: 'actions',
                  sortable: false,
                  filterable: false,
                  width: '20%',
               },
            ]
         }
      },
   },
   methods: {
      getDateString (dateVal) {
         return formattedDateTimeString(dateVal)
      },
      async getPerformers (value) {
         await axios.get('/api/users').then((response) => {
            response.data.forEach((element) => {
               if (!element.contact_person) {
                  console.log(element)
               }
            })
            const performers = response.data.reduce((returnObj, person, index) => {
               returnObj[index] = {
                  id: person.id,
                  contactPersonId: person.contact_person_id,
                  fullName:
              person.contact_person.first_name +
              ' ' +
              person.contact_person.last_name,
               }
               return returnObj
            }, [])
            const performer =
          performers.find((performer) => {
             return performer.id === value
          }).contactPersonId ?? null
            this.setPerformer(performer, performers)
         })
      },
      setPerformer (performer) {
         this.performer = performer
      },
      async savePerformer (offerData) {
         await axios
            .patch(`/api/offerData/${offerData}/performer`, {
               performer: this.performer,
            })
            .then((response) => {
               this.$inertia.reload({ only: ['offerDataList'] })
            })
      },
      deleteItem (item) {
         if (confirm(`Soll das Angebot ${item.id} wirklich gelöscht werden?`)) {
            this.$inertia.delete(this.route('offerData.destroy', item.id))
         }
      },
      setPublishOffer (item) {
         this.publishOffer = item
         this.dialog = true
      },
      publishItem () {
         this.$inertia.post(
            this.route('offer.store', {
               offerData: this.publishOffer.id,
               term: this.term,
            })
         )
      },
      async duplicateItem (item) {
         await axios
            .post(`/api/offerData/${item.id}/replicate`)
            .then((response) => {
               console.log(response)
               // this.editItem(response.data.id);
            })
            .catch((error) => {
               console.log(error.response)
            })
      },
      navigateToPriceinformation (_priceinformation, second) {
         console.log(_priceinformation)
         console.log(second)

         this.$inertia.visit(this.route('offerData.show', _priceinformation))
      },
   },
}
</script>
